import type { App } from 'vue'
import { servicesKey } from '@/config/keys.ts'
import createServices from '@/services'
import type { AxiosInstance } from 'axios'

export default {
    install: (app: App, { axios }: { axios: AxiosInstance }) => {
        app.provide(servicesKey, createServices(axios))
    },
}
